import { Badge, Dropdown } from "react-bootstrap";
import {
  formatContentDate,
  getContentPageCount,
  getContentTopLevelKeys,
  getThemeColors,
  shortenId,
} from "../../utils/content.utils";

const ColorSwatch = ({ color, label }) => {
  if (!color) return null;
  return (
    <span
      title={`${label}: ${color}`}
      style={{
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: 3,
        backgroundColor: color,
        border: "1px solid rgba(0,0,0,0.15)",
        marginRight: 4,
        verticalAlign: "middle",
      }}
    />
  );
};

const ThemePreview = ({ content }) => {
  const theme = getThemeColors(content);
  if (!theme) return <span className="text-muted">—</span>;

  return (
    <span className="d-inline-flex align-items-center flex-wrap gap-1">
      <ColorSwatch color={theme.primaryColor} label="Primary" />
      <ColorSwatch color={theme.secondaryColor} label="Secondary" />
      <ColorSwatch color={theme.textColor} label="Text" />
      <ColorSwatch color={theme.buttonHoverColor} label="Button hover" />
    </span>
  );
};

const ContentsTable = ({ contents, onEdit, canManage }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 48 }}>#</th>
            <th style={{ minWidth: 120 }}>ID</th>
            <th style={{ width: 100 }}>Pages</th>
            <th style={{ minWidth: 140 }}>Theme</th>
            <th style={{ minWidth: 180 }}>Top-level keys</th>
            <th style={{ minWidth: 150 }}>Created</th>
            <th style={{ minWidth: 150 }}>Updated</th>
            <th className="text-center" style={{ width: 72 }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {contents.map((item, index) => {
            const contentId = item._id || item.id;
            const content = item.content || {};
            const keys = getContentTopLevelKeys(content);
            const pageCount = getContentPageCount(content);

            return (
              <tr key={contentId || `content-${index}`}>
                <td>{index + 1}</td>
                <td>
                  <code title={contentId || ""}>{shortenId(contentId)}</code>
                </td>
                <td>{pageCount}</td>
                <td>
                  <ThemePreview content={content} />
                </td>
                <td>
                  {keys.length ? (
                    <span className="d-inline-flex flex-wrap gap-1">
                      {keys.slice(0, 4).map((key) => (
                        <Badge key={key} bg="secondary">
                          {key}
                        </Badge>
                      ))}
                      {keys.length > 4 ? (
                        <Badge bg="light" text="dark">
                          +{keys.length - 4}
                        </Badge>
                      ) : null}
                    </span>
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>
                <td>{formatContentDate(item.created_at)}</td>
                <td>{formatContentDate(item.updated_at)}</td>
                <td className="text-center align-middle">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onEdit(item)}
                        disabled={!contentId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ContentsTable;
